export default {
  profile: {
    updateProfile: 'Atualização de perfil',
    signup: 'Registro'
  }
}
